import { Base64Helper } from "../../helpers/Base64Helper";

export class StorageService {

    set = (key: string, value?: any) => {
        if (!value) {
            localStorage.removeItem(key);
            return;
        }
        const json = JSON.stringify(value);
        const jsonBase64 = Base64Helper.utf8ToBase64(json);
        localStorage.setItem(key, jsonBase64);
    }

    get = <TResult>(key: string) => {
        const jsonBase64 = localStorage.getItem(key);
        const json = Base64Helper.base64ToUtf8(jsonBase64);
        return json ? JSON.parse(json) as TResult : null;
    }
}